import TagManager from 'react-gtm-module';

class TagManagerUtils {
  init = (gtmId) => {
    TagManager.initialize({ gtmId });
  };

  vpvMetodo = (evento, pagina, tipoSocio) => {
    TagManager.dataLayer({
      dataLayer: {
        event: evento,
        page: pagina,
        registrado: tipoSocio,
      },
    });
  };

  triggerEventMetodo = (evento, registro, accion, categoria, labset) => {
    TagManager.dataLayer({
      dataLayer: {
        event: evento,
        registrado: registro,
        'event-Config': {
          'eve-acc': accion,
          'eve-cat': categoria,
          'eve-lab': labset,
        },
      },
    });
  };

  triggerEventMetodoTwo = (evento, registro, accion, categoria, labset, tipoProducto) => {
    TagManager.dataLayer({
      dataLayer: {
        event: evento,
        registrado: registro,
        producto: tipoProducto,
        'event-Config': {
          'eve-acc': accion,
          'eve-cat': categoria,
          'eve-lab': labset,
        },
      },
    });
  };

  triggerEventMetodoThree = (evento, registro, accion, categoria, labset) => {
    TagManager.dataLayer({
      dataLayer: {
        event: evento,
        'event-Config': {
          'eve-acc': accion,
          'eve-cat': categoria,
          'eve-lab': labset,
          registrado: registro,
        },
      },
    });
  };

  vpvMetodoTwo = (evento, pagina, tipoSocio, tipoProducto) => {
    TagManager.dataLayer({
      dataLayer: {
        event: evento,
        page: pagina,
        registrado: tipoSocio,
        producto: tipoProducto,
      },
    });
  };
}

export default new TagManagerUtils();
